<template>
	<!-- ----------------------------------------- -->
  <div 
    id="main"
      class="container container-fluidd-flex p-0 pt-4 flex-column text-center" 
      v-bind:class="($i18n.locale == 'ar') ? 'rtl' : ''">
    
    <div class="row m-0 p-0 mb-4 px-4">
        
      <div class="col m-0 p-0" v-bind:class="($i18n.locale == 'ar') ? 'text-end' : 'text-start'">
          <img class="" id="logo" src="@/assets/logo-text.svg">
      </div>

      <div class="col p-0" v-bind:class="($i18n.locale == 'ar') ? 'text-start' : 'text-end'">
        <div @click="switchLang" id="lang" class="mt-2">
          <img v-if="$i18n.locale == 'en'" src="@/assets/svg/eg.svg">
          <img v-if="$i18n.locale == 'ar'" src="@/assets/svg/uk.svg">
          <span class="mx-1">{{ $i18n.locale == 'ar' ? 'English' : 'العربية'}}</span>
        </div>
      </div>
        
    </div>

    <template v-if="isMobile">


    <div class="row m-0 p-0 mb-4 px-5">
        <div class="col p-0">
          <p id="title">{{ $t('title') }}</p>
        </div>
      </div>

      <div class="row m-0 p-0 mb-4">
        <div class="col m-0 p-0 px-5">
          <p id="subtitle">{{ $t('subtitle') }}</p>
        </div>
      </div>
    <div class="row m-0 p-0 mb-5 px-2">
        <div class="col m-0 p-0 position-relative">
            <img class="w-85 m-0 p-0" src="@/assets/iphone.png">
            <img id="circle" src="@/assets/svg/circle.svg">
            <img id="robot" src="@/assets/anim/robot2.gif">
            <p id="innertext" >{{ $t('hello_drsnd') }}</p>
        </div>
      </div>
  
      <div class="row m-0 p-0 px-3 mb-2">
        <div class="col-3 p-0 text-center"><img src="@/assets/svg/1.svg"></div>
        <div class="col-9 p-0"><p class="text">{{ $t('home_text1') }}</p></div>
      </div>
      <div class="row m-0 p-0 px-3 mb-4">
        <div class="col-3 p-0"></div>
        <div class="col-9 p-0"><p class="subtext">{{ $t('home_subtext1') }}</p></div>
      </div>

      <div class="row m-0 p-0 px-3 mb-2">
        <div class="col-3 p-0 text-center"><img src="@/assets/svg/2.svg"></div>
        <div class="col-9 p-0"><p class="text">{{ $t('home_text2') }}</p></div>
      </div>
      <div class="row m-0 p-0 px-3 mb-4">
        <div class="col-3 p-0"></div>
        <div class="col-9 p-0"><p class="subtext">{{ $t('home_subtext2') }}</p></div>
      </div>
      
      <div class="row m-0 p-0 px-3 mb-2">
        <div class="col-3 p-0 text-center"><img src="@/assets/svg/3.svg"></div>
        <div class="col-9 p-0"><p class="text">{{ $t('home_text3') }}</p></div>
      </div>
      <div class="row m-0 p-0 px-3 mb-4">
        <div class="col-3 p-0"></div>
        <div class="col-9 p-0"><p class="subtext">{{ $t('home_subtext3') }}</p></div>
      </div>
      
      <div class="row m-0 p-0 px-3 mb-2">
        <div class="col-3 p-0 text-center"><img src="@/assets/svg/4.svg"></div>
        <div class="col-9 p-0"><p class="text">{{ $t('home_text4') }}</p></div>
      </div>
      <div class="row m-0 p-0 px-3 mb-4">
        <div class="col-3 p-0"></div>
        <div class="col-9 p-0"><p class="subtext">{{ $t('home_subtext4') }}</p></div>
      </div>

    </template>
    
    <template v-else>
      <!-- <div class="row m-0 p-0 flex-grow-1"></div> -->

      <div class="row m-0 p-0">
        <!-- ------------------------------- -->
        <div class="col-8 m-0 p-0">

          <div class="container h-100 p-5">
            <div class="row mb-4">
              <div id="title" class="col"><p>{{ $t('title') }}</p></div>
            </div>
            <div class="row mb-4">
              <div id="subtitle" class="col"><p>{{ $t('subtitle') }}</p></div>
            </div>
            <div class="row mb-1">
              <div class="col-1"><img src="@/assets/svg/2.svg"></div>
              <div class="col-5"><p class="text">{{ $t('home_text2') }}</p></div>
              <div class="col-1"><img src="@/assets/svg/1.svg"></div>
              <div class="col-5"><p class="text">{{ $t('home_text1') }}</p></div>
            </div>
            <div class="row mb-4">
              <div class="col-1"> <div class="vr"></div> </div>
              <div class="col-5"><p class="subtext">{{ $t('home_subtext2_1') }} <b> {{ $t('home_subtext2_2') }} </b> {{ $t('home_subtext3') }}</p></div>
              <div class="col-1"> <div class="vr"></div> </div>
              <div class="col-5"><p class="subtext">{{ $t('home_subtext1') }}</p></div>
            </div>
            <div class="row mb-1">
              <div class="col-1"><img src="@/assets/svg/3.svg"></div>
              <div class="col-5"><p class="text">{{ $t('home_text3') }}</p></div>
              <div class="col-1"><img src="@/assets/svg/4.svg"></div>
              <div class="col-5"><p class="text">{{ $t('home_text4') }}</p></div>
            </div>
            <div class="row mb-4">
              <div class="col-1"></div>
              <div class="col-5"><p class="subtext">{{ $t('home_subtext3') }}</p></div>
              <div class="col-1"></div>
              <div class="col-5"><p class="subtext">{{ $t('home_subtext4') }}</p></div>
            </div>
          </div>

        </div>
        <!-- ------------------------------- -->
        <!-- ------------------------------- -->
        <div class="col-4 m-0 p-0 pt-4 position-relative" id="overflow">
          <img id="phone" src="@/assets/iphone.png">
          <img id="circle" src="@/assets/svg/circle.svg">
          <img id="robot" src="@/assets/anim/robot2.gif">
          <p id="innertext" >{{ $t('hello_drsnd') }}</p>
          <p id="innertext2" >{{ $t('comming_soon') }}</p>
        </div>
        <!-- ------------------------------- -->
        <!-- ------------------------------- -->
        <!-- ------------------------------- -->
        
      </div>

    </template>
    
    <!-- <span id="copyright">Copyright © drsnd.com</span> -->
  </div>
  <!-- //////////////////////////////////////////////////////////////////////////////////////////////////// -->

  <!-- <div id="box">
    

    <img id="logo" class="center-x" src="@/assets/logo-text.svg">
    <p id="title" class="center-x" >{{ $t('title') }}</p>
    <p id="subtitle" class="center-x" >{{  $t('subtitle') }}</p>
    
    
    <img id="iphone" class="center-x" src="@/assets/iphone.png">
    <img id="drsnd" class="center-x" src="@/assets/drsnd.png">


    <p id="text1">{{ $t('home_text1')  }}</p>
    <p id="text2">{{ $t('home_text2')  }}</p>
    <p id="text3">{{ $t('home_text3')  }}</p>
    <p id="text4">{{ $t('home_text4')  }}</p>
    <img id="line1" src="@/assets/line1.svg">
    <img id="line2" src="@/assets/line2.svg">
    <img id="line3" src="@/assets/line3.svg">
    <img id="line4" src="@/assets/line4.svg">
  </div> -->
</template>

<script>

export default {
  name: 'LandingPage',
  async created() {           //when the page load
    this.$i18n.locale = await this.$store.state.lang;               //load the lang from the local storage
    //document.title = (this.$i18n.locale == 'en') ? 'SND' : 'سند';
  },
  computed:{
    isMobile(){
      return screen.width <= 760 || /Mobi|Android/i.test(navigator.userAgent);
    },
    fixDirection(){
      return (this.$i18n.locale == 'ar') ? 'text-end' : 'text-start';
    },
  },
  methods:{
    isMobile2(){
      return screen.width <= 760;
      // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    async switchLang(){
      this.$i18n.locale = (this.$i18n.locale == 'ar') ? 'en' : 'ar'
      await this.$store.dispatch('lang', this.$i18n.locale);        //save to local storage
      // document.title = (this.$i18n.locale == 'en') ? 'SND' : 'سند';
    }
  }
}
</script>

<style scoped>
html, body, #app{
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  max-width: 100% !important;
  min-width: 100% !important;

  height: 100%;
  max-height: 100% !important;
  min-height: 100% !important;

  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
@font-face {
  font-family: Poppins;
  src: url('@/assets/fonts/Poppins-Regular.ttf');
  font-weight: 400;
}
@font-face {
  font-family: Poppins;
  src: url('@/assets/fonts/Poppins-Bold.ttf');
  font-weight: 700;
}
@font-face {
  font-family: Bahij;
  src: url('@/assets/fonts/Bahij-Regular.ttf');
  font-weight: 400;
}
@font-face {
  font-family: Bahij;
  src: url('@/assets/fonts/Bahij-Bold.ttf');
  font-weight: 700;
}
.w-80{
  width: 80% !important;
  min-width: 80% !important;
  max-width: 80% !important;
}
.w-85{
  width: 85% !important;
  min-width: 85% !important;
  max-width: 85% !important;
}
.w-90{
  width: 90% !important;
  min-width: 90% !important;
  max-width: 90% !important;
}
*{
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  font-family: Poppins;
}
p{
  margin: 0;
  padding: 0;
}
#main{
  width: 100% !important;
  max-width: 100% !important;
  
  height: 100% !important;
  max-height: 100% !important;
  
  /* border: 1px solid red; */
  min-height: 100vh !important; 
  /* box-sizing: border-box; */
  /* background: radial-gradient(circle at 30% 50%, #a6f0e5, #ffffff, #d7b5f8); */
  /* background: radial-gradient(circle at 30% 50%, #AFE6E6, #C6E7EE, #DAA5F5); */
  background: radial-gradient(circle at 100% 50%, #AFE6E6, #82E1E1, #FFFFFF, #FBF4FF, #CC94EB);
}
.rtl, .rtl p{
  direction: rtl !important;
}
.rtl *{
  font-family: Bahij !important;
}

.rtl .text, .rtl .subtext{
  text-align: right !important;
}

#logo{
    width: 100px;
}
/* -------------------------- */
#overflow{
  overflow: hidden !important;
}
/* -------------------------- */
#lang *{
  font-family: Bahij !important;
  font-size: 16pt;
  color: #3C1053;
  cursor: pointer;
}
#lang img{
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  height: 24px;
}
.rtl > #lang{
  font-family: Poppins !important;
}
#lang span{
  vertical-align: middle;
}
/* -------------------------- */
#title{
  font-weight: bold;
  line-height: 150%;
  font-size: 30px;
  color: #3A2152;
  text-align: center;
}
/* -------------------------- */
#subtitle{
  font-size: 20px;
  /* font-size: clamp(16px, 3vh, 28px); */
  line-height: 120%;
  color: #3A2152;
  text-align: center;
  margin: auto !important;
  left: 0;
  right: 0;
  /* margin-left: calc(50% - 760px / 2);  */
  /* max-width: 760px; */
}
.vr{
  margin-top: 50%;
  width: 2px;
  height: 50%;
  box-sizing: border-box;
  border: 1px solid black;
}

/* Mobile CSS */
@media screen and (max-width: 760px) {
  #main{
    padding-bottom: 5em !important;
  }
  /* -------------------------- */
  #circle{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 60%;
    margin: auto;
  }
  #robot{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 60%;
    margin: auto;
  }

  #innertext{
    position: absolute;
    font-weight: bold;
    font-size: 32px;
    color: #3A2152;
    top: 12%;
    left: 0;
    right: 0;
    width: 50%;
    line-height: 150%;
    margin: auto;
  }
  .text{
    font-weight: bold;
    font-size: 26px;
    color: #3A2152;
    text-align: left;
  }
  .subtext{
    font-size: 20px;
    line-height: 120%;
    color: #3A2152;
    text-align: left;
  }
  #copyright{
    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    margin: auto;
    color: #3A2152;
    font-size: 12pt;
  }
}

/* Desktop CSS */
@media screen and (min-width: 761px) {
  #phone{
    width: 85%;
  }
  /* -------------------------- */
  #circle{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 60%;
    margin: auto;
  }
  #robot{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 60%;
    margin: auto;
  }

  #innertext{
    position: absolute;
    font-weight: bold;
    font-size: 32px;
    color: #3A2152;
    top: 15%;
    left: 0;
    right: 0;
    width: 50%;
    line-height: 150%;
    margin: auto;
  }
  #innertext2{
    position: absolute;
    font-weight: bold;
    font-size: 32px;
    color: #3A2152;
    bottom: 15%;
    left: 0;
    right: 0;
    width: 50%;
    line-height: 150%;
    margin: auto;
  }
  .rtl #title, .rtl #subtitle{
    text-align: right;
  }
  #title{
    font-size: 38pt;
    text-align: left;
    line-height: 150%;
  }
  #subtitle{
    font-size: 18pt;
    text-align: left;
    line-height: 150%;
  }
  .text{
    text-align: left;
    font-weight: bold;
    font-size: 18pt;
  }
  .subtext{
    text-align: left;
    font-size: 14pt;
  }
  #copyright{
    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    margin: auto;
    color: #3A2152;
    font-size: 12pt;
  }

}
</style>
